import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowRight, FileText } from 'lucide-react'

export default function CTA() {
  return (
    <section id="about" className="relative pt-28 md:pt-32 pb-24 md:pb-32 bg-slate-900 overflow-hidden">
      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-sm font-semibold text-accent uppercase tracking-wider mb-3">Investor Relations</h2>
            <h3 className="text-3xl md:text-4xl font-bold font-heading text-white tracking-tight mb-4">
              Lynas Rare Earths Limited
            </h3>
            <p className="text-lg text-slate-300 leading-relaxed max-w-2xl mx-auto">
              Listed on the Australian Securities Exchange. Access our latest reports, presentations and corporate information.
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="flex items-center px-6 py-4 rounded-lg bg-white/5 border border-white/10 backdrop-blur-sm"
            >
              <span className="font-mono text-base font-bold text-white">
                <span className="text-slate-400 font-medium">ASX:</span>{' '}
                <span className="text-accent">LYC</span>
                <span className="ml-2 text-slate-200">$19.07</span>
              </span>
            </motion.div>
            <Link
              to="/investors"
              className="inline-flex items-center gap-3 px-8 py-4 text-base font-semibold rounded-lg bg-accent text-white hover:bg-accent/90 transition-colors"
            >
              <FileText className="h-5 w-5" />
              Investor Centre
              <ArrowRight className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
